(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("externalLoginConfigurations", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/registration/externalLoginConfigurations/externalLoginConfigurationsView.html",
            controller: ["externalLoginConfigurationResource", "messageService", "$state", ExternalLoginConfigurationsCtrl],
            controllerAs: "vm"
        };
        function ExternalLoginConfigurationsCtrl(externalLoginConfigurationResource, messageService, $state) {
            var vm = this;
            vm.sortableOptions = {
                handle: '.cursor-move',
                axis: "y",
                stop: function () {
                    vm.saveOrder();
                }
            };
            vm.loading = true;
            externalLoginConfigurationResource.getExternalLoginConfigurationViewModel(function (result) {
                vm.externalLoginConfigurations = result;
                vm.loading = false;
            }, function (error) {
                vm.loading = false;
                console.error(error);
            });
            vm.saveOrder = function () {
                var externalLoginConfigurations = angular.copy(vm.externalLoginConfigurations);
                for (var i in externalLoginConfigurations) {
                    if (externalLoginConfigurations.hasOwnProperty(i)) {
                        externalLoginConfigurations[i].order = parseInt(i) + 1;
                    }
                }
                externalLoginConfigurationResource.saveOrder({ externalLoginConfigurations: externalLoginConfigurations }, function () {
                    messageService.success("common.changesSaved");
                }, function () {
                    messageService.error("common.genericError");
                });
            };
            vm.addExternalLogin = function () {
                $state.go("main.settings.addExternalLoginConfiguration.step1");
            };
            vm.editExternalLogin = function (provider) {
                $state.go("main.settings.editExternalLoginConfiguration", provider);
            };
        }
    });
}());
